<template>
  <main class="pa-15 mb-10">
    <!--  main_title -->
    <h1 class="text-h5 text-xl-h4 mb-2 mb-xl-6">
      {{ stakeholdersData.main_title }}
    </h1>

    <!--  main_subtitle  -->

    <p
      v-safe-html="stakeholdersData.main_subtitle"
      :class="[
        'mb-8 lato-font-medium lato-text-sm',
        { 'lato-text-md': $vuetify.display.xlOnly },
      ]"
    />

    <!--  main_title_2 -->
    <h2 class="text-h5 text-xl-h4 mb-2 mb-xl-6">
      {{ stakeholdersData.main_title_2 }}
    </h2>

    <!--  content  -->
    <div
      v-for="(item, index) in stakeholdersData.stakeholders_data"
      :key="index"
    >
      <a :id="item.anchor" />
      <h3 class="text-h6 text-xl-h5 mb-2">
        {{ item.title }}
      </h3>
      <p
        v-safe-html="item.content"
        :class="[
          'mb-8 lato-font-medium lato-text-sm',
          { 'lato-text-md': $vuetify.display.xlOnly },
        ]"
      />
    </div>
  </main>
</template>

<script>
import stakeholdersData from "@/data/stakeholdersData.json";
import getHostname from "@/utils/generalUtils";

export default {
  name: "Stakeholders",
  mixins: [getHostname],
  data: () => {
    return {
      stakeholdersData: stakeholdersData.stakeholders,
    };
  },
};
</script>
<style>
p {
  /* make the line of paragraph to break when reaching /n in a string
   same time having breaking lines and justify texts
   */
  white-space: pre-line;
  text-align: justify;
  -moz-text-align-last: justify;
}
</style>
